import styled from "styled-components";

export const CategoryTitle = styled.h3`
    color:$color-green-900;
    font-size:32px;
    margin: 0;
    font-weight: 600;
    @media (max-width: 768px) {
        font-size:24px;
    }
`;

export const ImageTitle = styled.label`
    color:$color-green-900;
    font-size:20px;
    margin: 0;
    font-weight: 600;
`;

export const SeparatorBlue600 = styled.hr`
    color:$color-green-600;
    border-top: 1px solid;
    opacity: 1;
    margin: 0;
`;

export const SeparatorWhite = styled.hr`
width: 100%;
height: 1px;
background: white;
display: block;
margin-left: 0px;
margin-top: 24px;
opacity: 1;
color: white;`;


export const SeparatorGrey = styled.hr`
width: 100%;
height: 1px;
background: #D9DADB;
display: block;
margin-left: 0px;
margin-top: 24px;
opacity: 1;
color: #D9DADB;`;

